import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/*eslint-disable */

declare const window: any;

interface BannerVehiculosComponentProps {
  banner: any;
  setVisibleHICS: any;
  visibleHICS: any;
}

const BannerVehiculosComponent: React.FC<BannerVehiculosComponentProps> = ({
  banner,
  setVisibleHICS,
  visibleHICS,
}) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? "landscape" : "portrait"
  );

  useEffect(() => {
    const handleLoad = () => {
      setIsVisible(true);
    };

    const updateOrientation = () => {
      setOrientation(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
      );
    };

    handleLoad();

    // Agrega un listener para actualizar la orientación en cada cambio de tamaño de ventana
    window.addEventListener("resize", updateOrientation);

    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, [location]);

  const selectedHICS = () => {
    setVisibleHICS(true);
  };

  return (
    <div
      className={`banner-vehiculos-detail-component ${
        isVisible ? "visible" : ""
      } ${visibleHICS ? "oculto" : ""}`}
      style={{
        backgroundImage: `url(https://manager.hyundaicolombia.co/${
          orientation === "portrait" && banner?.srcPortrait !== undefined ? banner?.srcPortrait : banner?.src
        })`,
      }}
    >
      <div className="title-banner-vehiculos-detail-component template-2">
        {banner.title}
      </div>
      <img className="sello-banner-vehiculos-detail-component" src={`https://manager.hyundaicolombia.co/${banner?.sello}`} alt="sello hyundai colombia" />
      {banner?.ICSH !== null ? (
        <div className="experiencia-banner-vehiculos-detail-component" onClick={selectedHICS}>
          Ver experiencia en 3D
        </div>
      ) : null}
      <div className="mousey">
        <div className="scroller"></div>
      </div>
      <div className="mousey-desc">Scroll para continuar</div>
    </div>
  );
};

export default BannerVehiculosComponent;
